import configCommon from './config.common.json';
import production from './config.production.json';
import beta from './config.beta.json';
import local from './config.local.json';
import staging from './config.staging.json';
import preview from './config.preview.json';

let config: Bemob.Config;

const configName =
  import.meta.env?.VUE_APP_CONFIG_NAME
  ?? (typeof process !== 'undefined' ? process.env.VUE_APP_CONFIG_NAME : undefined)
  ?? 'staging';

switch (configName) {
  case 'production':
    config = production;
    break;
    
  case 'beta':
    config = beta;
    break;

  case 'local':
    config = local;
    break;

  case 'preview':
    config = preview;
    break;

  case 'staging':
  case 'development':
  default:
    config = staging;
    break;
}

export default {
  ...configCommon,
  ...config
} as Bemob.Config;
